import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "../PaymentForm";
import { useCreateSetupIntent } from "../../services/queries";
import { Box, Typography, Button, Paper, CircularProgress } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function AddPayment({ closeModal }) {
  const { data, isLoading, isError, error } = useCreateSetupIntent();
  const clientSecret = data?.data?.client_secret || "";

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
        minHeight={220}
        py={4}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Preparing secure payment…
        </Typography>
      </Box>
    );
  }

  if (isError || !clientSecret) {
    return (
      <Paper sx={{ p: 3, maxWidth: 560, margin: "24px auto" }} elevation={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 44 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Payment initialization failed
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mt: 0.5 }}
            >
              {error?.message ||
                "We couldn't initialize the payment form right now. Please try refreshing the page or try again later."}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Box>
      </Paper>
    );
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <PaymentForm onCancel={closeModal} />
    </Elements>
  );
}
